import { useEffect, RefObject } from 'react'

export function useClickOutside(
  ref: RefObject<HTMLElement>,
  handler: () => void,
  enabled: boolean
) {
  useEffect(() => {
    if (!enabled) return

    const onPointer = (e: MouseEvent | TouchEvent) => {
      const target = e.target as Node
      if (ref.current && !ref.current.contains(target)) {
        handler()
      }
    }

    // Use pointerdown for both mouse and touch; fallback to mousedown/touchstart
    // for broad compatibility.
    document.addEventListener('mousedown', onPointer)
    document.addEventListener('touchstart', onPointer)

    return () => {
      document.removeEventListener('mousedown', onPointer)
      document.removeEventListener('touchstart', onPointer)
    }
  }, [ref, handler, enabled])
}
